import { MapfreCardComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent],
  selector: 'app-claims-wrapper',
  templateUrl: './claims.component.html',
})
export class ClaimsWrapperComponent implements OnInit {
  claims: any;
  classForPage: string;
  loading: boolean;

  constructor(
    public router: Router,
  ) { }

  checkRoute(): void {
    if (
      this.router.url === '/claims/active' ||
      this.router.url === '/claims/closed'
    ) {
      this.classForPage = 'claims';
    } else {
      this.classForPage = 'claim-detail';
    }
  }

  ngOnInit() {
    this.checkRoute();
  }
}
